import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDelete = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_994_6131",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_994_6131)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.92723 3.52721C9.2648 3.18964 9.72263 3 10.2 3H13.8C14.2774 3 14.7353 3.18964 15.0728 3.52721C15.4104 3.86477 15.6 4.32261 15.6 4.8V6.6H18.2895C18.2958 6.59993 18.3022 6.59993 18.3085 6.6H19.2C19.6971 6.6 20.1 7.00294 20.1 7.5C20.1 7.99706 19.6971 8.4 19.2 8.4H19.1281L18.2997 18.3412C18.289 19.0424 18.0058 19.7126 17.5092 20.2092C17.0029 20.7155 16.3161 21 15.6 21H8.40002C7.68394 21 6.99718 20.7155 6.49084 20.2092C5.99421 19.7126 5.71103 19.0424 5.70034 18.3412L4.8719 8.4H4.80002C4.30297 8.4 3.90002 7.99706 3.90002 7.5C3.90002 7.00294 4.30297 6.6 4.80002 6.6H5.69151C5.69787 6.59993 5.70422 6.59993 5.71055 6.6H8.40002V4.8C8.40002 4.32261 8.58967 3.86477 8.92723 3.52721ZM6.67814 8.4L7.49692 18.2253C7.49899 18.2501 7.50002 18.2751 7.50002 18.3C7.50002 18.5387 7.59485 18.7676 7.76363 18.9364C7.93241 19.1052 8.16133 19.2 8.40002 19.2H15.6C15.8387 19.2 16.0676 19.1052 16.2364 18.9364C16.4052 18.7676 16.5 18.5387 16.5 18.3C16.5 18.2751 16.5011 18.2501 16.5031 18.2253L17.3219 8.4H6.67814ZM13.8 6.6H10.2V4.8H13.8V6.6ZM10.2 10.2C10.6971 10.2 11.1 10.6029 11.1 11.1V16.5C11.1 16.9971 10.6971 17.4 10.2 17.4C9.70297 17.4 9.30002 16.9971 9.30002 16.5V11.1C9.30002 10.6029 9.70297 10.2 10.2 10.2ZM13.8 10.2C14.2971 10.2 14.7 10.6029 14.7 11.1V16.5C14.7 16.9971 14.2971 17.4 13.8 17.4C13.303 17.4 12.9 16.9971 12.9 16.5V11.1C12.9 10.6029 13.303 10.2 13.8 10.2Z",
			fill: "currentColor"
		})
	})]
});
export default SvgDelete;
